import { useQuery } from "@tanstack/react-query";
import i18n from "../../../i18n";
import { QueryConfig, ExtractFnReturnType } from "../../../lib/react-query";
import { getClaimFollowUpsByClaimId } from "../api/ClaimFollowUpAPI";

type QueryFnTypeClaimFollowUpByIdClaim = typeof getClaimFollowUpsByClaimId;

export const useClaimFollowUpByIdClaim = (
    claimId: number,
    config?: QueryConfig<QueryFnTypeClaimFollowUpByIdClaim>
) => {
    return useQuery<ExtractFnReturnType<QueryFnTypeClaimFollowUpByIdClaim>>({
        ...config,
        queryKey: ["claimFollowUpByIdClaim", claimId, i18n.language],
        queryFn: () => getClaimFollowUpsByClaimId(claimId),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!claimId,
    });
};
